import { render } from "./Videos.vue?vue&type=template&id=13d8e6eb&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"

import "./Videos.vue?vue&type=style&index=0&id=13d8e6eb&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d8e6eb"]])

export default __exports__